module.exports = __webpack_public_path__ + "static/media/art.a0eef6c9.svg";